import { useCallback, useRef, useState } from "react";

import { SaveStatus } from "@/types";

export function useSaveIndicator() {
  const [status, setStatus] = useState<SaveStatus>("idle");
  const timeoutRef = useRef<ReturnType<typeof setTimeout>>();

  // For selects/instant interactions — tied to actual save promise
  const trigger = useCallback((maybePromise?: Promise<void> | void) => {
    clearTimeout(timeoutRef.current);
    setStatus("saving");

    const minDelay = new Promise<void>((r) => setTimeout(r, 500));

    const savePromise =
      maybePromise instanceof Promise ? maybePromise : Promise.resolve();

    void Promise.all([savePromise, minDelay]).then(() => {
      setStatus("saved");
      timeoutRef.current = setTimeout(() => {
        setStatus("idle");
      }, 2000);
    });
  }, []);

  // For text-based inputs — debounced on keystroke, purely cosmetic
  const handleChange = useCallback(() => {
    clearTimeout(timeoutRef.current);
    setStatus("saving");

    timeoutRef.current = setTimeout(() => {
      setStatus("saved");
      timeoutRef.current = setTimeout(() => {
        setStatus("idle");
      }, 2000);
    }, 500);
  }, []);

  return { handleChange, status, trigger };
}
